import axios from 'axios';
import { baseUrl } from '../hooks/useEndpoints';
import {
  ICreateTrainingCategoryBody,
  IReorderTrainingCategoriesBody,
  ITrainingCategory,
  IUpdateTrainingCategoryBody,
} from '../models/allenamenti';

/**
 * Le tre rotte di scrittura restituiscono la tassonomia risolta COMPLETA, non
 * il solo documento toccato: il client la tiene in cache e gli serve comunque
 * intera, quindi la mutation può scrivere direttamente la nuova lista senza
 * una seconda GET.
 */
export const allenamentiTaxonomyEndpoints = {
  /** Categorie di sistema più quelle del tenant, già annidate. */
  list: () =>
    axios.get<ITrainingCategory[]>(`${baseUrl}/training-blocks/categories`),

  create: (body: ICreateTrainingCategoryBody) =>
    axios.post<ITrainingCategory[]>(
      `${baseUrl}/training-blocks/categories`,
      body,
    ),

  update: (slug: string, body: IUpdateTrainingCategoryBody) =>
    axios.patch<ITrainingCategory[]>(
      `${baseUrl}/training-blocks/categories/${slug}`,
      body,
    ),

  /**
   * Ordine di visualizzazione della tassonomia per questa società.
   *
   * Accetta anche gli slug di sistema: non le modifica, registra soltanto in
   * che ordine questa società vuole vederle. Vedi ADR 027.
   */
  reorder: (body: IReorderTrainingCategoriesBody) =>
    axios.put<ITrainingCategory[]>(
      `${baseUrl}/training-blocks/categories/order`,
      body,
    ),

  /** 409 con `code: 'CATEGORY_IN_USE'` e `usedBy` se dei blocchi la usano. */
  remove: (slug: string) =>
    axios.delete<ITrainingCategory[]>(
      `${baseUrl}/training-blocks/categories/${slug}`,
    ),
};
